import { find } from "lodash";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import Dropdown from "../../components/shared/DropDown";
import { Button, Grid, Container, Card, Chip, Stack } from "@mui/material";
import List from "../../components/shared/List";
import Dialog from "../../components/shared/Dialog";

import RHFAutocomplete from "../../components/shared/RHFAutocomplete";
import { color } from "../../utils/constant";

import { useForm } from "react-hook-form";

import {
  getPaginationInfo,
  getPatientList,
  getAppointmentList,
} from "../../data/selectors/Appointment/appointment.selector";
import { resetState } from "../../data/reducers/Appointment/appointmentform.reducer";

import useAppointment from "../../data/talons/Appointment/useAppointment";
import MaterialUIPickers from "../../components/shared/DesktopDatePicker";
import AppointmentForm from "./AppointmentForm";
import { useAppointmentForm } from "../../data/talons/Appointment/useAppointmentForm";
export default function Appointment() {
  const [showDialog, setShowDialog] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [editId, setEditId] = useState(null);
  const AppointmentList = useSelector(getAppointmentList);
  const dispatch = useDispatch();
  const patientList = useSelector(getPatientList);
  const paginationInfo = useSelector(getPaginationInfo);
  const [showAppoinmentForm, setShowAppoinmentForm] = useState(false);

  const {
    gridHeaders,
    loading,
    loader,
    status,
    StatusList,
    PatientId,
    findpatientFromLabel,
    handleStatusChange,
    fetchAppointmentList,
    fetchDoctorComboList,
    fetchPatientComboList,
    FromDate,
    UptoDate,
    handleFromDate,
    handleUptoDate,
  } = useAppointment();
  const { getAppointmentbyId } = useAppointmentForm();
  useEffect(() => {
    fetchDoctorComboList();
    fetchPatientComboList();
    fetchAppointmentList({
      current_page: 1,
      row_count: rowsPerPage,
    });
  }, [rowsPerPage]);

  const { setValue, control } = useForm();
  const onSubmit = useCallback(
    async (e) => {
      e?.preventDefault();
      await fetchAppointmentList({
        current_page: 1,
        row_count: rowsPerPage,
      });
    },
    [fetchAppointmentList]
  );

  const openAppoinmentForm = () => {
    setShowAppoinmentForm(true);
  };

  return (
    <>
      {showAppoinmentForm === false ? (
        <Container
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            mt: 1,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3} md={2}>
              <MaterialUIPickers
                required
                id="from_date"
                label="From Date"
                type="date"
                value={FromDate}
                size={"small"}
                onChange={handleFromDate}
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              ></MaterialUIPickers>
            </Grid>
            <Grid item xs={12} sm={3} md={2}>
              <MaterialUIPickers
                required
                id="upto_date"
                label="Upto Date"
                type="date"
                value={UptoDate}
                size={"small"}
                onChange={handleUptoDate}
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              ></MaterialUIPickers>
            </Grid>

            {/* <Grid item xs={12} sm={3} md={2}>
              <RHFAutocomplete
                borderRadius={"12px"}
                isRequired={true}
                name="patient_name"
                label="Patient Name"
                disabled={editId ? true : false}
                freeSolo
                data={patientList || []}
                defaultValue={PatientId}
                onInputChange={(value) => findpatientFromLabel(value)}
                id={patientList?.map((option) => option.id)}
                renderOption={(props, option) => (
                  <>
                    <li {...props} key={option}>
                      {option}
                    </li>
                  </>
                )}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option}
                      label={option}
                      size="small"
                      color="info"
                      variant="soft"
                    />
                  ))
                }
                control={control}
                setValue={setValue}
              />
            </Grid> */}

            <Grid item xs={12} sm={3} md={2}>
              <Dropdown
                size={"small"}
                title={"Status"}
                data={StatusList}
                handleDropdownChange={handleStatusChange}
                dropdownValue={status}
                // allReqired={true}
                // allStatusVal="0"
              />
            </Grid>
            <Grid
              container
              direction="row"
              justify="flex-right"
              item
              xs={6}
              sm={3}
              md={2}
            >
              <Button
                variant="contained"
                onClick={onSubmit}
                sx={{
                  maxHeight: 40,
                  backgroundColor: color.button,
                  borderRadius: 3,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
              >
                Get Data
              </Button>
            </Grid>
            {/* <Grid
              item
              xs={6}
              sm={3}
              md={2}
              sx={{ marginLeft: "auto", textAlign: "end" }}
            >
              <Dialog
                handleClose={() => {
                  setShowDialog(false);
                  setEditId(null);
                  fetchAppointmentList({
                    current_page: 1,
                    row_count: rowsPerPage,
                  });
                }}
                open={showDialog}
                fullWidth={true}
              ></Dialog>
            </Grid> */}
          </Grid>
          <Card
            sx={{
              flexGrow: { md: 1 },
              display: { md: "flex" },
              flexDirection: { md: "column" },
              my: "12px",
              borderRadius: "12px",
              boxShadow:
                "0 0 2px 0 rgba(145, 158, 171, 0.2),0 12px 24px -4px rgba(145, 158, 171, 0.12)",
            }}
          >
            <List
              loading={loading}
              data={AppointmentList}
              paginationData={paginationInfo}
              columnsData={gridHeaders}
              getRowId={(row) => row.id}
              autoHeight={true}
              pageCount={Number(paginationInfo.total_page)}
              totalRecords={paginationInfo.total_count}
              onPageChange={async (page, rowsPerPage) => {
                setRowsPerPage(rowsPerPage);
                await fetchAppointmentList({
                  current_page: page,
                  row_count: rowsPerPage,
                });
              }}
              enableView
              onViewIconPress={async (id) => {
                await getAppointmentbyId(id);
                setEditId(id);
                setShowDialog(true);
                setShowAppoinmentForm(true);
              }}
            />
          </Card>
        </Container>
      ) : (
        <Stack sx={{ p: 3 }}>
          <AppointmentForm
            postSubmit={async () => {
              setEditId(null);
              await fetchAppointmentList({
                current_page: 1,
                row_count: rowsPerPage,
              });
              dispatch(resetState());
            }}
            editId={editId}
            backToAppointment={() => {
              fetchAppointmentList({
                current_page: 1,
                row_count: rowsPerPage,
              });
              setShowAppoinmentForm(false);
              setEditId(null);
            }}
          />
        </Stack>
      )}
    </>
  );
}
